<template>
  <div class="odmik-vsebine-nastavtive-telefonija mobile-odmik">
    <div>
      <el-dialog
        top="30vh"
        width="530px"
        append-to-body
        class="uspesno-obvestilo mobile"
        :visible.sync="centerDialogVisible"
        center>
        <div class="ikona-uspesno">
          <img src="/static/img/MojT2/Eposlovanje/Icon-feather-alert-circle.png">
        </div>
        <div style="padding-bottom: 45px">
          <p class="navadno-besedilo text-block-center okno-center">
            Z izbiro te možnosti bodo onemogočeni vsi odhodni klici.
          </p>
        </div>
        <div style="text-align: center; margin-bottom: 27px;">
          <el-button class="gumb-brez-obrob crna krepko" @click="centerDialogVisible = false">
            Prekliči
          </el-button>
          <el-button class="gumb-potrdi" @click="PersonalBlokade()">
            DA, ŽELIM VKLOPITI BLOKADO
          </el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        top="30vh"
        width="530px"
        append-to-body
        class="uspesno-obvestilo mobile"
        :visible.sync="centerDialogVisibleRedirect"
        center>
        <div class="ikona-uspesno">
          <img src="/static/img/MojT2/Eposlovanje/Icon-feather-alert-circle.png">
        </div>
        <div style="padding-bottom: 45px">
          <p class="navadno-besedilo text-block-center okno-center">
            Z izbiro te možnosti bodo onemogočeni vsi odhodni klici preusmerjenih številk.
          </p>
        </div>
        <div style="text-align: center; margin-bottom: 27px;">
          <el-button class="gumb-brez-obrob crna krepko" @click="centerDialogVisibleRedirect = false">
            Prekliči
          </el-button>
          <el-button class="gumb-potrdi" @click="RedirectBlokadePotrditev()">
            DA, ŽELIM VKLOPITI BLOKADO
          </el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        top="30vh"
        width="530px"
        append-to-body
        class="uspesno-obvestilo mobile"
        :visible.sync="centerDialogVisibleDirect"
        center>
        <div class="ikona-uspesno">
          <img src="/static/img/MojT2/Eposlovanje/Icon-feather-alert-circle.png">
        </div>
        <div style="padding-bottom: 45px">
          <p class="navadno-besedilo text-block-center okno-center">
            Z izbiro te možnosti bodo onemogočeni vsi odhodni klici.
          </p>
        </div>
        <div style="text-align: center; margin-bottom: 27px;">
          <el-button class="gumb-brez-obrob crna krepko" @click="centerDialogVisibleDirect = false">
            Prekliči
          </el-button>
          <el-button class="gumb-potrdi" @click="DirectPotrditevBlokade()">
            DA, ŽELIM VKLOPITI BLOKADO
          </el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <div v-if="!poslovnaStranka">
        <p class="navadno-besedilo" style="padding-top: 30px">
          Za izbrano telefonsko številko lahko nastavite blokado klicev. Izberete lahko eno ali več blokad.
        </p>
      </div>
      <div v-if="imenaStevilBlokad.length > 0" class="blokade-poslovna" v-loading="nalaganjeZaporeKlicev">
        <div class="postavitev-mobilna-telefonija blokade">
          <el-checkbox v-for="ime in imenaStevilBlokad"
                       :label="ime"
                       :key="ime"
                       v-model="listaOzacenihBlokad"
                       :disabled="ime === 'Vse številke' ? false : (blokadaVseh || (ime === imePremijskeZaporeOsebne && blokadaPremium))"
                       :class="ime === 'Vse številke' ? 'krepko-obkljukano' : ''"
                       @change="GetInfoKolikoJeOzancenih">
            {{ ime }}
          </el-checkbox>
          <br>
        </div>
      </div>
      <div v-if="poslovnaStranka">
        <div>
          <h4 class="h4-blokada-direktnih-klicev">
            Blokada direktnih odhodnih klicev
          </h4>
          <p class="navadno-besedilo" style="padding-top: 5px">
            Za izbrano telefonsko številko lahko nastavite blokado klicev. Izberete lahko eno ali več blokad.
          </p>
          <div v-if="imenaStevilBlokadDirect.length > 0" class="blokade-poslovna" v-loading="nalaganjeZaporeKlicev">
            <div class="postavitev-mobilna-telefonija-biznis blokade">
              <el-checkbox v-for="ime in imenaStevilBlokadDirect"
                           :label="ime"
                           :key="ime"
                           v-model="listaOzacenihBlokadDirect"
                           :disabled="ime === 'Vse številke' ? false : blokadaVsehDirect || (ime === imePremijskeZaporeOsebne && blokadaPremium)"
                           :class="ime === 'Vse številke' ? 'krepko-obkljukano' : ''"
                           @change="GetInfoKolikoJeOzancenihDirect">
                {{ ime }}
              </el-checkbox>
              <br>
            </div>
          </div>
        </div>
        <div class="hr-odmik-klicev-biznis">
          <hr class="hr-stil"/>
        </div>
        <div style="padding-top: 26px">
          <h4 class="h4-blokada-odhodnih-klicev">
            Blokada odhodnih klicev preusmerjenih številk
          </h4>
          <p class="navadno-besedilo" style="padding-top: 20px">
            Ob vklopu blokade izbranega omrežja, preusmeritve klicev na telefonske številke, ki so vključene v to omrežno
            blokado, ne bodo izvedene.
          </p>
          <div v-if="imenaStevilBlokadRedirect.length > 0" class="blokade-poslovna preusmerjeni-klici" v-loading="nalaganjeZaporeKlicev">
            <div class="postavitev-mobilna-telefonija-biznis blokade">
              <el-checkbox v-for="ime in imenaStevilBlokadRedirect"
                           :label="ime"
                           :key="ime"
                           v-model="listaOzacenihBlokadRedirect"
                           :disabled="ime === 'Vse številke' ? false : blokadaVsehRedirect"
                           :class="ime === 'Vse številke' ? 'krepko-obkljukano' : ''"
                           @change="GetInfoKolikoJeOzancenihRedirect">
                {{ ime }}
              </el-checkbox>
              <br>
            </div>
          </div>
        </div>
      </div>
      <div class="postavitev-gumb-biznis" v-if="!nalaganjeZaporeKlicev">
        <el-button class="gumb-potrdi" @click="SetZaporeKlicev()">
          SHRANI SPREMEMBE
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import {Button, Checkbox, Collapse, CollapseItem, Dialog, Option, Select, TabPane, Tabs} from 'element-ui'
import ClientAgent from '../../../../../../assets/js/clientAgent.js'

export default {
  name: 'BlokadeKlicov',
  data () {
    return {
      listaOzacenihBlokad: [],
      imenaStevilBlokad: [],
      nalaganjeZaporeKlicev: false,
      centerDialogVisible: false,
      blokadaVseh: false,
      blokadaPremium: false,
      imePremijskeZaporeOsebne: '',
      imenaStevilBlokadDirect: [],
      listaOzacenihBlokadDirect: [],
      blokadaVsehDirect: false,
      blokadaVsehRedirect: false,
      imenaStevilBlokadRedirect: [],
      listaOzacenihBlokadRedirect: [],
      poslovnaStranka: false,
      centerDialogVisibleRedirect: false,
      centerDialogVisibleDirect: false,
      idBlokadDirect: [],
      idBlokadRedirect: []
    }
  },
  props: {
    izbranPrikljucek: String,
    izbranaTelefonska: String
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Select.name]: Select,
    [Option.name]: Option,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [Dialog.name]: Dialog
  },
  watch: {
    izbranaTelefonska: function () {
      if (this.izbranPrikljucek !== null) {
        this.GetZaporeKlicev()
      }
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.GetZaporeKlicev()
  },
  methods: {
    PersonalBlokade () {
      this.listaOzacenihBlokad.push('Vse številke')
      this.centerDialogVisible = false
      this.blokadaVseh = true
      this.SetZaporeKlicev()
    },
    DirectPotrditevBlokade () {
      this.blokadaVsehDirect = null
      this.listaOzacenihBlokadDirect.push('Vse številke')
      this.centerDialogVisibleDirect = false
      this.blokadaVsehDirect = true
      this.SetZaporeKlicev()
    },
    RedirectBlokadePotrditev () {
      this.listaOzacenihBlokadRedirect.push('Vse številke')
      this.centerDialogVisibleRedirect = false
      this.blokadaVsehRedirect = true
      this.SetZaporeKlicev()
    },
    GetInfoKolikoJeOzancenih () {
      this.blokadaVseh = false
      if (this.listaOzacenihBlokad.length > 5) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Nastavljenih je lahko največ 5 blokad klicev!'
        this.ShowWarningMessage(paramObvestilo)
        this.listaOzacenihBlokad.pop(6)
      }
      for (let i = 0; i < this.listaOzacenihBlokad.length; i++) {
        if (this.listaOzacenihBlokad[i] === 'Vse številke') {
          this.listaOzacenihBlokad = []
          this.centerDialogVisible = true
          break
        }
      }
    },
    GetInfoKolikoJeOzancenihDirect () {
      this.blokadaVsehDirect = false
      if (this.listaOzacenihBlokadDirect.length > 5) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Nastavljenih je lahko največ 5 blokad direktnih odhodnih klicev!'
        this.ShowWarningMessage(paramObvestilo)
        this.listaOzacenihBlokadDirect.pop(6)
      }
      for (let i = 0; i < this.listaOzacenihBlokadDirect.length; i++) {
        if (this.listaOzacenihBlokadDirect[i] === 'Vse številke') {
          this.listaOzacenihBlokadDirect = []
          this.centerDialogVisibleDirect = true
          break
        }
      }
    },
    GetInfoKolikoJeOzancenihRedirect () {
      this.blokadaVsehRedirect = false
      if (this.listaOzacenihBlokadRedirect.length > 5) {
        let paramObvestilo = {}
        paramObvestilo.message = 'Nastavljenih je lahko največ 5 blokad odhodnih klicev preusmerjenih številk!'
        this.ShowWarningMessage(paramObvestilo)
        this.listaOzacenihBlokadRedirect.pop(6)
      }
      for (let i = 0; i < this.listaOzacenihBlokadRedirect.length; i++) {
        if (this.listaOzacenihBlokadRedirect[i] === 'Vse številke') {
          this.listaOzacenihBlokadRedirect = []
          this.centerDialogVisibleRedirect = true
          break
        }
      }
    },
    GetZaporeKlicev () {
      if (this.izbranPrikljucek !== null) {
        this.nalaganjeZaporeKlicev = true
        let param = ['idPrikljucek=' + this.izbranPrikljucek]
        param.push('stevilka=' + this.izbranaTelefonska)
        this.clientAgent.postWsRequest(this,
          'prikljucek/telefonija/getZaporeKlicev?',
          param,
          null,
          'PridobljeniPodatkiZaporeKlicev',
          'ErrPridobljeniPodatkiZaporeKlicev')
      }
    },
    PridobljeniPodatkiZaporeKlicev (podatki) {
      this.poslovnaStranka = false
      this.blokadaVsehDirect = false
      this.blokadaVsehRedirect = false
      this.blokadaVseh = false
      this.blokadaPremium = false
      this.imePremijskeZaporeOsebne = ''
      this.imeIdBlokad = []
      this.imenaStevilBlokad = []
      this.listaOzacenihBlokad = []
      this.idBlokadDirect = []
      this.imeIdBlokadRedirect = []
      this.imenaStevilBlokadRedirect = []
      this.listaOzacenihBlokadRedirect = []
      this.idBlokadDirect = []
      this.imeIdBlokadDirect = []
      this.imenaStevilBlokadDirect = []
      this.listaOzacenihBlokadDirect = []
      this.poslovnaStranka = podatki.data.businessNumber
      if (podatki.data.businessNumber) {
        this.PoslovnaTelefonija(podatki)
      } else {
        this.OsebnaTelefonija(podatki)
      }
      this.nalaganjeZaporeKlicev = false
    },
    ErrPridobljeniPodatkiZaporeKlicev (podatki) {
      this.nalaganjeZaporeKlicev = false
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
    },
    // Zaklepanje premijske zapore (editableBySelfCare) velja samo za osebno telefonijo,
    // za poslovne linije (direct/redirect) vedenje ostaja nespremenjeno.
    PoslovnaTelefonija (podatki) {
      let direct = this.ObdelajListoZapor(podatki.data.direct)
      this.imeIdBlokadDirect = direct.imeIdBlokad
      this.imenaStevilBlokadDirect = direct.imenaStevil
      this.listaOzacenihBlokadDirect = direct.listaOzacenih
      this.blokadaVsehDirect = direct.blokadaVseh
      let redirect = this.ObdelajListoZapor(podatki.data.redirect)
      this.imeIdBlokadRedirect = redirect.imeIdBlokad
      this.imenaStevilBlokadRedirect = redirect.imenaStevil
      this.listaOzacenihBlokadRedirect = redirect.listaOzacenih
      this.blokadaVsehRedirect = redirect.blokadaVseh
    },
    ObdelajListoZapor (listaBlokad) {
      let rezultat = {
        imeIdBlokad: [],
        imenaStevil: [],
        listaOzacenih: [],
        blokadaVseh: false
      }
      for (let propt in listaBlokad) {
        let zapora = listaBlokad[propt]
        let formatName = zapora.name.replace(/_/, ' ')
        let prikaznoIme = formatName === 'Vse stevilke' ? 'Vse številke' : formatName
        rezultat.imeIdBlokad.push({ id: zapora.id, name: formatName })
        rezultat.imenaStevil.push(prikaznoIme)
        if (zapora.enabled === true) {
          rezultat.listaOzacenih.push(prikaznoIme)
          if (formatName === 'Vse stevilke') {
            rezultat.blokadaVseh = true
          }
        }
      }
      return rezultat
    },
    OsebnaTelefonija (podatki) {
      let listaBlokad = podatki.data.personal
      for (let propt in listaBlokad) {
        this.objektIdBlokad = {}
        this.objektIdBlokad.id = listaBlokad[propt].id
        this.objektIdBlokad.name = listaBlokad[propt].name
        this.imeIdBlokad.push(this.objektIdBlokad)
        if (listaBlokad[propt].name === 'all') {
          this.imenaStevilBlokad.push('Vse številke')
          if (listaBlokad[propt].enabled === true) {
            this.listaOzacenihBlokad.push('Vse številke')
            this.blokadaVseh = true
          }
        } else if (listaBlokad[propt].name !== 'all') {
          this.imenaStevilBlokad.push(listaBlokad[propt].name)
        }
        if (listaBlokad[propt].enabled === true && listaBlokad[propt].name !== 'all') {
          this.listaOzacenihBlokad.push(listaBlokad[propt].name)
        }
        if (listaBlokad[propt].editableBySelfCare === false) {
          this.imePremijskeZaporeOsebne = listaBlokad[propt].name
          this.blokadaPremium = true
        }
      }
    },
    SetZaporeKlicev () {
      this.nalaganjeZaporeKlicev = true
      this.idBlokadPersonal = []
      this.idBlokadDirect = []
      this.idBlokadRedirect = []
      if (this.listaOzacenihBlokad.length !== 0) {
        for (let propt in this.imeIdBlokad) {
          for (let j = 0; j < this.listaOzacenihBlokad.length; j++) {
            if (this.imeIdBlokad[propt].name === this.listaOzacenihBlokad[j] ||
              (this.imeIdBlokad[propt].name === 'all' &&
                this.listaOzacenihBlokad[j] === 'Vse številke')) {
              if (this.idBlokadPersonal.indexOf(this.imeIdBlokad[propt].id) === -1) {
                this.idBlokadPersonal.push(this.imeIdBlokad[propt].id)
                break
              }
            }
          }
        }
      } else {
        this.idBlokadPersonal = []
      }
      if (this.listaOzacenihBlokadDirect.length !== 0) {
        for (let propt in this.imeIdBlokadDirect) {
          for (let j = 0; j < this.listaOzacenihBlokadDirect.length; j++) {
            if (this.imeIdBlokadDirect[propt].name === this.listaOzacenihBlokadDirect[j] ||
              (this.imeIdBlokadDirect[propt].name === 'Vse stevilke' &&
                this.listaOzacenihBlokadDirect[j] === 'Vse številke')) {
              if (this.idBlokadDirect.indexOf(this.imeIdBlokadDirect[propt].id) === -1) {
                this.idBlokadDirect.push(this.imeIdBlokadDirect[propt].id)
                break
              }
            }
          }
        }
      } else {
        this.idBlokadDirect = []
      }
      if (this.listaOzacenihBlokadRedirect.length !== 0) {
        for (let propt in this.imeIdBlokadRedirect) {
          for (let j = 0; j < this.listaOzacenihBlokadRedirect.length; j++) {
            if (this.imeIdBlokadRedirect[propt].name === this.listaOzacenihBlokadRedirect[j] ||
              (this.imeIdBlokadRedirect[propt].name === 'Vse stevilke' &&
                this.listaOzacenihBlokadRedirect[j] === 'Vse številke')) {
              if (this.idBlokadRedirect.indexOf(this.imeIdBlokadRedirect[propt].id) === -1) {
                this.idBlokadRedirect.push(this.imeIdBlokadRedirect[propt].id)
                break
              }
            }
          }
        }
      } else {
        this.idBlokadRedirect = []
      }
      let param = ['idPrikljucek=' + this.izbranPrikljucek]
      param.push('stevilka=' + this.izbranaTelefonska)
      param.push('personal[]=' + this.idBlokadPersonal)
      param.push('direct[]=' + this.idBlokadDirect)
      param.push('redirect[]=' + this.idBlokadRedirect)
      this.clientAgent.postWsRequest(
        this,
        'prikljucek/telefonija/setZaporeKlicev?',
        param,
        null,
        'SetShranjeneZaporeKlicev',
        'ErrShranjeneZaporeKlicev')
    },
    SetShranjeneZaporeKlicev () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno posodobljeno.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetZaporeKlicev()
      this.blokadaVseh = false
      this.blokadaVsehDirect = false
      this.blokadaVsehRedirect = false
      this.nalaganjeZaporeKlicev = false
    },
    ErrShranjeneZaporeKlicev (podatki) {
      this.GetZaporeKlicev()
      this.ShowWarningMessage(podatki)
      this.nalaganjeZaporeKlicev = false
    }
  }
}
</script>
<style scoped
       src="../../../../../../../static/css/Nastavitve/Telefonija/NastavitveStacionarnaTelefonija/BlokadeKlicev.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/NastavitveTelefonije/NastavitveStacionarnaTelefonija/BlokadeKlicov.vue